import axiosInstance from '@/shared/apiClient/axiosInstance';
import { apiRequest, type ApiResponse } from '@/shared/apiClient/apiRequest';
import type { AuthState } from '@/shared/auth/authStore';

export type LoginResponse = {
  accessToken?: string;
  passwordUpdateRequired?: boolean;
};

export type MeResponse = AuthState['userInfo'];

export const authApi = {
  login: async (data: { loginId: string; password: string }): Promise<ApiResponse<LoginResponse>> => {
    const response = await axiosInstance.post('/api/auth/login', data);
    return response.data;
  },

  getMe: (): Promise<ApiResponse<MeResponse>> => {
    return apiRequest.get('/api/user/me');
  },
};
